import { useIntl } from "react-intl";
import React, { useState, useEffect } from "react";
import { Dropdown, Header, Form } from "semantic-ui-react";

const ModifiedMallampati = (props) => {
  const intl = useIntl();
  const [mallampati, setMallampati] = useState<any>("");
  const [imagePath, setImagePath] = useState("");

  useEffect(() => {
    handleChangeMallapati("class_1");
  }, []);
  const handleChangeMallapati = (value) => {
    const find = mallampatiOptions.find((option) => option.value === value);
    setMallampati(value);
    setImagePath(find.img);
  };
  return (
    <div className="mouth-area" style={{ margin: props.hiddenEvaluation ? "0px" : "50px 0 0 80px" }}>
      <Header as="h4" style={{ margin: "0px" }}>
        {intl.formatMessage({ id: "cukey122" })}
      </Header>
      <Form>
        <Form.Field>
          <Dropdown value={mallampati} options={mallampatiOptions} selection onChange={(ev, { value }) => handleChangeMallapati(value)} />
        </Form.Field>
        <img
          src={imagePath}
          alt="modified mallampati"
          style={{
            width: "195px",
            height: "260px",
            marginTop: "-10px",
          }}
        />
      </Form>
    </div>
  );
};
export default React.memo(ModifiedMallampati);

const mallampatiOptions = [
  {
    text: "Class I: Soft palate, uvala, fauces, pillars visible",
    value: "class_1",
    img: process.env.PUBLIC_URL + "/static/images/mallampatiClass1.png",
  },
  {
    text: "Class II: Soft palate, uvula, fauces visible",
    value: "class_2",
    img: process.env.PUBLIC_URL + "/static/images/mallampatiClass2.png",
  },
  {
    text: "Class III: Soft palate, base of uvala visible",
    value: "class_3",
    img: process.env.PUBLIC_URL + "/static/images/mallampatiClass3.png",
  },
  {
    text: "Class IV: Only Hard palate visible",
    value: "class_4",
    img: process.env.PUBLIC_URL + "/static/images/mallampatiClass4.png",
  },
];
